// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconButton_wrapper__QwoX9","iconWrapper":"IconButton_iconWrapper__Z8Kuv","disabled":"IconButton_disabled__3mpBs","offScreen":"IconButton_offScreen__2iE88"};